import { apiFetch } from '../lib/api';

// Applications API functions
export async function getApplications(filters = {}) {
  const params = new URLSearchParams();
  
  // Add filters to query params
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });

  const queryString = params.toString();
  const url = queryString ? `/api/applications?${queryString}` : '/api/applications';
  
  const r = await apiFetch(url);
  if (!r.ok) throw new Error('Applications fetch failed');
  return r.json();
}

export async function getApplication(id) {
  const r = await apiFetch(`/api/applications?id=eq.${id}&select=*`);
  if (!r.ok) throw new Error('Application fetch failed');
  return r.json();
}

export async function createApplication(applicationData) {
  const r = await apiFetch('/api/applications', {
    method: 'POST',
    body: JSON.stringify(applicationData)
  });
  if (!r.ok) throw new Error('Application creation failed');
  return r.json();
}

export async function updateApplication(id, applicationData) {
  const r = await apiFetch(`/api/applications?id=eq.${id}`, {
    method: 'PATCH',
    body: JSON.stringify(applicationData)
  });
  if (!r.ok) throw new Error('Application update failed');
  return r.json();
}

export async function deleteApplication(id) {
  const r = await apiFetch(`/api/applications?id=eq.${id}`, {
    method: 'DELETE'
  });
  if (!r.ok) throw new Error('Application deletion failed');
  return r.json();
}

export async function getMyApplications() {
  // Önce applications'ı çek
  const r = await apiFetch('/api/applications?select=*');
  if (!r.ok) throw new Error('My applications fetch failed');
  const applications = await r.json();
  
  
  // Her application için app detaylarını çek
  const applicationsWithApps = await Promise.all(
    applications.map(async (app) => {
      try {

        // Apps tablosundaki mevcut ID'leri kontrol et
        const allAppsResponse = await apiFetch(`/api/apps?select=id,title,platform,description`);
        const allAppsData = await allAppsResponse.json();

        
        // Eğer eşleşme yoksa, tüm ID'leri karşılaştır
        if (!allAppsData.find(app => app.id === app.app_id)) {

        }
        
        const appResponse = await apiFetch(`/api/apps?id=eq.${app.app_id}&select=id,title,platform,description`);
        const appData = await appResponse.json();

        return {
          ...app,
          app: appData[0] || null
        };
      } catch (error) {
        console.error('App fetch error:', error);
        return {
          ...app,
          app: null
        };
      }
    })
  );
  
  return applicationsWithApps;
}

export async function getApplicationsForApp(appId) {
  const r = await apiFetch(`/api/applications?app=eq.${appId}&select=*`);
  if (!r.ok) throw new Error('Applications for app fetch failed');
  return r.json();
}

export async function updateApplicationStatus(id, status) {
  const r = await apiFetch(`/api/applications?id=eq.${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ status })
  });
  if (!r.ok) throw new Error('Application status update failed');
  return r.json();
}

export async function addFeedback(id, feedback, rating) {
  const r = await apiFetch(`/api/applications?id=eq.${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ 
      feedback, 
      rating, 
      status: 'completed',
      completedAt: new Date().toISOString()
    })
  });
  if (!r.ok) throw new Error('Feedback addition failed');
  return r.json();
}
